import { useHistory, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { ChevronRight } from 'ts-react-feather-icons';

const useStyles = makeStyles(() => ({
  title: {
    color: '#8DA8B2',
  },
  parentRoute: {
    color: '#8DA8B2',
    cursor: 'pointer',
  },
  routeIconContainer: {
    verticalAlign: 'middle',
  },
  text: {
    color: 'black',
    fontWeight: 600,
  },
}));

type Props = {
  path: string;
};

const ProfilePath = ({ path }: Props) => {
  const classes = useStyles();
  const history = useHistory();

  const { portalId } = useParams<Record<string, string>>();

  return (
    <Typography className={classes.title} variant="h5">
      <span
        className={clsx(classes.parentRoute, classes.routeIconContainer)}
        onClick={() => {
          if (portalId) {
            history.push(`/home/${portalId}/home`);
            return;
          }

          history.push('/home');
        }}
      >
        <span className={classes.routeIconContainer}>
          <img src="/home-icon.svg" alt="home-icon" />
        </span>
        <span className={classes.routeIconContainer}>
          <ChevronRight />
        </span>
      </span>
      <span className={classes.text}>{path}</span>
    </Typography>
  );
};
export default ProfilePath;
